module.exports = __webpack_public_path__ + "static/media/collectio.c2b56260.png";